import { render } from "./SavedCollectionsContainer.vue?vue&type=template&id=4a031ff0&scoped=true"
import script from "./SavedCollectionsContainer.vue?vue&type=script&lang=js"
export * from "./SavedCollectionsContainer.vue?vue&type=script&lang=js"

import "./SavedCollectionsContainer.vue?vue&type=style&index=0&id=4a031ff0&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a031ff0"]])

export default __exports__